interface ProgressBarProps {
  value: number;
  label?: string;
  showPercentage?: boolean;
}

export default function ProgressBar({
  value,
  label,
  showPercentage = true,
}: ProgressBarProps) {
  const normalizedValue = Math.min(100, Math.max(0, value));

  return (
    <div className="app-progress">
      {(label || showPercentage) && (
        <div className="app-progress__labels">
          {label && <span>{label}</span>}
          {showPercentage && <strong>{Math.round(normalizedValue)}%</strong>}
        </div>
      )}
      <div
        className="app-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(normalizedValue)}
      >
        <span className="app-progress__bar" style={{ width: `${normalizedValue}%` }} />
      </div>
    </div>
  );
}
